import { render, staticRenderFns } from "./MobileNotifications.vue?vue&type=template&id=f77b6640&scoped=true&"
import script from "./MobileNotifications.js?vue&type=script&lang=js&"
export * from "./MobileNotifications.js?vue&type=script&lang=js&"
import style0 from "./MobileNotifications.scss?vue&type=style&index=0&id=f77b6640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77b6640",
  null
  
)

export default component.exports